export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (_e) {
    return true;
  }
}
